export default function AppSection() {
  return (
    <section id="app" className="py-16 md:py-20 bg-background-100">
      <div className="max-w-5xl mx-auto px-4 md:px-6">
        <h2 className="font-heading text-2xl md:text-3xl text-foreground-900 text-center mb-3">
          移动观影
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10">
          随时随地畅享偶像综艺，手机平板无缝切换
        </p>
        <div className="bg-background-50 rounded-lg border border-background-200/70 p-6 md:p-10">
          <div className="flex flex-col lg:flex-row items-center gap-8">
            <div className="flex-1 text-center lg:text-left">
              <h3 className="text-lg font-semibold text-foreground-800 mb-3">
                爱豆影视移动端 — 随身携带的综艺宝库
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed mb-6">
                爱豆影视完美适配手机和平板设备，无需下载任何应用，打开浏览器即可享受
                1080P高清流畅播放体验。无论是在通勤路上、午休时间还是周末宅家，
                热门综艺、真人秀、偶像团体内容随时随地想看就看，不缓冲不卡顿。
              </p>
              <div className="flex flex-wrap justify-center lg:justify-start gap-4">
                <div className="flex items-center gap-2 text-sm text-foreground-600">
                  <i className="ri-smartphone-line text-primary-500 text-lg"></i>
                  <span>手机适配</span>
                </div>
                <div className="flex items-center gap-2 text-sm text-foreground-600">
                  <i className="ri-tablet-line text-accent-600 text-lg"></i>
                  <span>平板优化</span>
                </div>
                <div className="flex items-center gap-2 text-sm text-foreground-600">
                  <i className="ri-wifi-line text-secondary-600 text-lg"></i>
                  <span>无需下载</span>
                </div>
              </div>
            </div>
            <div className="flex-shrink-0">
              <div className="relative w-48 h-80 bg-background-200 rounded-2xl border-4 border-background-300 overflow-hidden">
                <div className="absolute inset-0 flex flex-col items-center justify-center p-4">
                  <div className="w-12 h-12 rounded-xl bg-primary-500 flex items-center justify-center mb-4">
                    <span className="font-heading text-lg text-background-50">爱豆</span>
                  </div>
                  <div className="space-y-3 w-full">
                    {[...Array(5)].map((_, i) => (
                      <div key={i} className="flex items-center gap-2">
                        <div className="w-10 h-7 rounded bg-primary-200/60 flex-shrink-0"></div>
                        <div className="flex-1 h-2 rounded-full bg-background-300"></div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}